import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15393b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-text": "正在提交数据，请稍后" }

import { ref, unref, onMounted } from 'vue';
import { FormRules, ElMessage } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { useLocales } from '@/hooks/useLocales';
import { useDictionary } from '@/store/dictionary.store';
import { GetMainstayInfoApi, MainstayCreateApi, MainstayModifyApi } from '@/apis/basics/mainstay.api';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const { t } = useLocales();
const { getSelectList } = useDictionary();

const show = ref<boolean>(false);
const loading = ref<boolean>(false);
const isEditor = ref<boolean>(false);

const dialogTitle = ref<string>(t('basics.mainstay.dialog.title.manage', '交易主体管理'));

const nations = ref<any[]>([]);
const businessStatus = ref<any[]>([]);

const formSchema = ref<any>({
	id: '',
	revision: '0',
	code: '',
	erp_code: '',
	name_cn: '',
	name_en: '',
	short_name: '',
	legal_name: '',
	legal_mobile: '',
	reg_address: '',
	credit_code: '',
	is_enabled: 'Y',
	sort: 100,
	remark: '',
	reg_day: moment().format('YYYY-MM-DD'),
	reg_nation: 'CN',
	business_status: '1',
});

/* 表单验证规则 */
const formRules: FormRules = {
	code: [{ required: true, message: t('basics.mainstay.dialog.validation.codeRequired', '主体编号不能留空'), trigger: 'blur' }],
	erp_code: [{ required: true, message: t('basics.mainstay.dialog.validation.erpCodeRequired', '主体Erp编号不能留空'), trigger: 'blur' }],
	name_cn: [{ required: true, message: t('basics.mainstay.dialog.validation.nameCnRequired', '主体名称不能留空'), trigger: 'blur' }],
	reg_day: [{ required: true, message: t('basics.mainstay.dialog.validation.regDayRequired', '请选择注册日期'), trigger: 'blur' }],
	reg_nation: [{ required: true, message: t('basics.mainstay.dialog.validation.regNationRequired', '请选择注册国家'), trigger: 'blur' }],
	reg_address: [{ required: true, message: t('basics.mainstay.dialog.validation.regAddressRequired', '请输入注册地址'), trigger: 'blur' }],
	business_status: [{ required: true, message: t('basics.mainstay.dialog.validation.businessStatusRequired', '请选择企业经营状态'), trigger: 'blur' }],
	credit_code: [{ required: true, message: t('basics.mainstay.dialog.validation.creditCodeRequired', '统一社会信用代码不能留空'), trigger: 'blur' }],
};

// legal_name: [{ required: true, message: '法人姓名不能留空', trigger: 'blur' }],
// legal_mobile: [{ required: true, message: '法人联系方式不能留空', trigger: 'blur' }],

/* 获取印章记录明细 */
const getMainstayDetail = (rowId: string) => {
	loading.value = true;

	GetMainstayInfoApi(rowId)
		.then((res) => {
			const { succeeded, errors, data } = res;

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				formSchema.value = Object.assign({}, data);
			}
		})
		.finally(() => {
			loading.value = false;
		});
};

/* 打开对话框 */
const showDialog = (rowId: string, editor: boolean) => {
	if (editor) {
		getMainstayDetail(rowId);
	} else {
		formSchema.value = Object.assign({
			is_enabled: 'Y',
			revision: '0',
			sort: 100,
			reg_day: moment().format('YYYY-MM-DD'),
			reg_nation: 'CN',
			business_status: '1',
		});
	}

	dialogTitle.value = editor ? t('basics.mainstay.dialog.title.edit', '编辑交易主体') : t('basics.mainstay.dialog.title.add', '新增交易主体');
	isEditor.value = editor;

	show.value = true;
};

/* 选择用户后 */
// const onUserSelect = (user: any) => {

//     unref(formSchema).managers_id = user[0].id

// }

/* 点击保存按钮 */
const onSaveBtnClick = () => {
	const formData = unref(formSchema);

	const api = !unref(isEditor) ? MainstayCreateApi : MainstayModifyApi;

	api(formData)
		.then((res) => {
			const { succeeded, errors, data } = res;

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success(t('messages.saveSuccess', '保存成功'));
				show.value = false;
			}
		})
		.finally(() => {
			$emits('refresh');
		});
};

expose({ showDialog });

onMounted(() => {
	nations.value = getSelectList('nation');
	businessStatus.value = getSelectList('business_status');
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((show).value = $event)),
    title: dialogTitle.value,
    style: {"width":"800px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        disabled: loading.value,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.save', '保存')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (show.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.closed', '关闭')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          size: "small",
          ref: "formRef",
          "label-width": "140px",
          model: formSchema.value,
          "label-position": 'right',
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.code', '编号'),
                      prop: "code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.code,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.code) = $event)),
                          type: "text",
                          placeholder: _unref(t)('basics.mainstay.dialog.form.placeholder.code', '请输入编号')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.erpCode', 'Erp系统编号'),
                      prop: "erp_code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.erp_code,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.erp_code) = $event)),
                          type: "text",
                          placeholder: _unref(t)('basics.mainstay.dialog.form.placeholder.erpCode', '请输入Erp系统编号')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.nameCn', '主体名称'),
                      prop: "name_cn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.name_cn,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.name_cn) = $event)),
                          type: "text",
                          placeholder: _unref(t)('basics.mainstay.dialog.form.placeholder.nameCn', '请输入主体名称')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.shortName', '名称简写')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.short_name,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.short_name) = $event)),
                          type: "text",
                          placeholder: _unref(t)('basics.mainstay.dialog.form.placeholder.shortName', '请输入名称简写')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.creditCode', '信用代码'),
                      prop: "credit_code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.credit_code,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.credit_code) = $event)),
                          type: "text",
                          placeholder: _unref(t)('basics.mainstay.dialog.form.placeholder.creditCode', '请输入统一社会信用代码')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.businessStatus', '经营状态'),
                      prop: "business_status"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.business_status,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.business_status) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessStatus.value, (dic) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: dic.label,
                                value: dic.value
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.regNation', '注册国家'),
                      prop: "reg_nation"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.reg_nation,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.reg_nation) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nations.value, (dic) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: dic.label,
                                value: dic.value
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.regDay', '注册日期'),
                      prop: "reg_day"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: formSchema.value.reg_day,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.reg_day) = $event)),
                          style: {"width":"100%"},
                          type: "date",
                          placeholder: _unref(t)('basics.mainstay.dialog.form.placeholder.regDay', '请选择注册日期'),
                          format: "YYYY-MM-DD",
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.regAddress', '注册地址'),
                      prop: "reg_address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.reg_address,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.reg_address) = $event)),
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "150",
                          rows: "3",
                          placeholder: _unref(t)('basics.mainstay.dialog.form.placeholder.regAddress', '请输入注册地址')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.sort', '排序')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formSchema.value.sort,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.sort) = $event)),
                          step: "100",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.remark', '备注'),
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.remark,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSchema.value.remark) = $event)),
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "200",
                          rows: "4",
                          placeholder: _unref(t)('basics.mainstay.dialog.form.placeholder.remark', '备注')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('basics.mainstay.dialog.form.status', '状态')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_enabled,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('status.enabled', '启用')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('status.diabled', '停用')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})